'use strict';

var StatementBoxDirective = function StatementBoxDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'StatementBoxController',
    template: require('../templates/statement-box.html'),
    scope: {
      rule: '=',
      strategy: '=',
      strategyGroup: '=?'
    },
    link: function link($scope) {
      $scope.$watch('rule', $scope.updateStatement, true);
      $scope.$watch('strategy', $scope.updateStatement, true);
      $scope.$watch('strategyGroup', $scope.updateStatement, true);
    }
  };
};
StatementBoxDirective.$inject = [];
module.exports = StatementBoxDirective;